module.exports = __webpack_public_path__ + "img/bg-pattern-bottom-mobile.02b87d67.svg";